var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Video"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video",
    clipPath: "url(#clip-Video)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409",
    transform: "translate(5 4.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M8.11,454.3H1.148a1.148,1.148,0,0,1,0-2.3H8.11a1.148,1.148,0,0,1,0,2.3Z",
    transform: "translate(0 -417.417)",
    fill: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M177.473,454.3H152.148a1.148,1.148,0,0,1,0-2.3h25.325a1.148,1.148,0,0,1,0,2.3Z",
    transform: "translate(-139.447 -417.417)",
    fill: "#dfe7f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M38.026,29.839H1.148A1.147,1.147,0,0,1,0,28.692V1.148A1.147,1.147,0,0,1,1.148,0H38.026a1.147,1.147,0,0,1,1.148,1.148V28.692A1.147,1.147,0,0,1,38.026,29.839Z",
    fill: "#e64545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M274.439,29.839a1.147,1.147,0,0,0,1.148-1.148V1.148A1.147,1.147,0,0,0,274.439,0H256V29.839Z",
    transform: "translate(-236.413)",
    fill: "#e64545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M64.443,122.3h-2.3a1.148,1.148,0,1,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Zm0,4.591h-2.3a1.148,1.148,0,1,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Zm0,4.591h-2.3a1.148,1.148,0,1,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Zm0,4.591h-2.3a1.148,1.148,0,1,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Z",
    transform: "translate(-56.333 -110.819)",
    fill: "#2e2e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M196.605,131.344a1.148,1.148,0,0,1-.605-1.012V121.15a1.147,1.147,0,0,1,1.784-.955l6.886,4.591a1.148,1.148,0,0,1,0,1.91l-6.886,4.591A1.15,1.15,0,0,1,196.605,131.344Z",
    transform: "translate(-181.004 -110.821)",
    fill: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M256,154.322l4.08-2.72a1.148,1.148,0,0,0,0-1.91l-4.08-2.72Z",
    transform: "translate(-236.413 -135.728)",
    fill: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M394.443,122.3h-2.3a1.148,1.148,0,0,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Z",
    transform: "translate(-361.084 -110.819)",
    fill: "#2e2e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M64.443,62.3h-2.3a1.148,1.148,0,0,1,0-2.3h2.3a1.148,1.148,0,0,1,0,2.3Z",
    transform: "translate(-56.333 -55.409)",
    fill: "#2e2e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M394.443,62.3h-2.3a1.148,1.148,0,0,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Zm0,9.181h-2.3a1.148,1.148,0,0,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Zm0,4.591h-2.3a1.148,1.148,0,0,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Zm0,4.591h-2.3a1.148,1.148,0,0,1,0-2.3h2.3a1.148,1.148,0,1,1,0,2.3Z",
    transform: "translate(-361.084 -55.409)",
    fill: "#2e2e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M94.443,428.886a3.443,3.443,0,1,1,3.443-3.443A3.447,3.447,0,0,1,94.443,428.886Z",
    transform: "translate(-84.037 -389.712)",
    fill: "#e64545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M139.443,425.443A3.447,3.447,0,0,0,136,422v6.886A3.447,3.447,0,0,0,139.443,425.443Z",
    transform: "translate(-125.594 -389.712)",
    fill: "#e64545"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.e7f6cf74.svg";
export { ForwardRef as ReactComponent };